/* eslint-disable simple-import-sort/imports */
import calendarIcon from 'assets/icons/hero/calendar.svg';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FloatingButton } from './styles';

const FloatingAppointmentButton = ({
  heroRef,
  contactFormRef,
  href,
  title,
}) => {
  const [showFloatingButton, setShowFloatingButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef?.current) return;

      const heroRect = heroRef.current.getBoundingClientRect();
      const heroBottom = heroRect.bottom;
      const viewportHeight = window.innerHeight;
      const threshold = viewportHeight * 0.35;

      let shouldShow = heroBottom < threshold;

      if (contactFormRef?.current) {
        const contactFormRect = contactFormRef.current.getBoundingClientRect();
        const isContactFormVisible =
          contactFormRect.top < viewportHeight && contactFormRect.bottom > 0;

        if (isContactFormVisible) {
          shouldShow = false;
        }
      }

      setShowFloatingButton(shouldShow);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [heroRef, contactFormRef]);

  return (
    <FloatingButton href={href} target="_blank" $visible={showFloatingButton}>
      <img src={calendarIcon} alt="Calendar" />
      {title}
    </FloatingButton>
  );
};

FloatingAppointmentButton.propTypes = {
  heroRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  contactFormRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

FloatingAppointmentButton.defaultProps = {
  contactFormRef: null,
};

export default FloatingAppointmentButton;
